import type { TColumnLabels, TShowColumn } from '@modules/items/types/items.types';

import { EDashboardSegmentKey } from '../types/dashboard.types';

type TDashboardItemsTableConfig = {
  show: TShowColumn;
  labels?: TColumnLabels;
};

const NON_REVIEW_SHOW: TShowColumn = {
  approvalOpenSince: true,
  approvedVersion: true,
  authors: true,
  date: false,
  reviewDue: false,
  reviewer: false,
  status: false,
  version: true,
};

const REVIEW_SHOW: TShowColumn = {
  approvalOpenSince: false,
  approvedVersion: true,
  authors: false,
  date: false,
  reviewDue: true,
  reviewer: true,
  status: false,
  version: true,
};

export const getDashboardItemsTableConfig = (segmentKey: EDashboardSegmentKey): TDashboardItemsTableConfig =>
  segmentKey === EDashboardSegmentKey.OVERDUE_REVIEWS || segmentKey === EDashboardSegmentKey.REVIEWS_DUE_SOON
    ? {
        show: REVIEW_SHOW,
        labels: { reviewDue: 'Due date' },
      }
    : { show: NON_REVIEW_SHOW };
